import { Link } from "react-router-dom";

export default function LegalPage() {
  return (
    <div className="min-h-dvh bg-background">
      <header className="sticky top-0 z-20 border-b bg-background/95 backdrop-blur">
        <div className="max-w-3xl mx-auto px-6 py-4">
          <Link to="/" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
            ← Volver al inicio
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-10 pb-16">
        <h1 className="text-2xl font-semibold tracking-tight mb-8">
          Política de Privacidad – Candidaturas
        </h1>

        <h3 className="text-lg font-medium mt-8 mb-3">Responsable del tratamiento</h3>
        <p className="text-sm text-muted-foreground mb-4">
          <strong>BRUTAL SC</strong><br />
          CIF: <strong>J19484948</strong><br />
          Dirección: <strong>C/ Bairén 1, Piso 2, Puerta 3, 46702 Gandía (Valencia), España</strong><br />
          Email de contacto: <a href="mailto:hola@brutalco.es" className="text-primary underline hover:no-underline">hola@brutalco.es</a><br />
          Sitio web: <strong>app.brutalco.es</strong>
        </p>

        <hr className="my-8 border-border" />

        <h3 className="text-lg font-medium mt-8 mb-3">1. Finalidad del tratamiento de los datos</h3>
        <p className="text-sm text-muted-foreground mb-4">
          Los datos personales facilitados por los candidatos a través del sitio web <strong>app.brutalco.es</strong> serán tratados con las siguientes finalidades:
        </p>
        <ul className="text-sm text-muted-foreground list-disc pl-6 space-y-1 mb-4">
          <li>Gestionar procesos de selección de personal.</li>
          <li>Evaluar candidaturas recibidas.</li>
          <li>Analizar la experiencia profesional, habilidades y perfil laboral del candidato.</li>
          <li>Organizar y clasificar las candidaturas dentro del sistema interno de gestión de candidatos.</li>
          <li>Contactar con los candidatos en relación con oportunidades laborales presentes o futuras.</li>
        </ul>

        <hr className="my-8 border-border" />

        <h3 className="text-lg font-medium mt-8 mb-3">2. Tratamiento automatizado y uso de inteligencia artificial</h3>
        <p className="text-sm text-muted-foreground mb-4">
          Como parte del proceso de gestión de candidaturas, los currículums y documentos enviados pueden ser <strong>analizados mediante herramientas automatizadas y sistemas de inteligencia artificial</strong> con el objetivo de:
        </p>
        <ul className="text-sm text-muted-foreground list-disc pl-6 space-y-1 mb-4">
          <li>Extraer información profesional relevante (experiencia, estudios, habilidades, idiomas, etc.).</li>
          <li>Clasificar perfiles profesionales.</li>
          <li>Organizar candidaturas dentro del sistema interno de gestión de talento.</li>
          <li>Facilitar la revisión y evaluación de candidatos.</li>
        </ul>
        <p className="text-sm text-muted-foreground mb-4">
          Este análisis automatizado <strong>no constituye una decisión totalmente automatizada con efectos jurídicos sobre el candidato</strong>, ya que las decisiones finales sobre la candidatura son revisadas por personal humano.
        </p>
        <p className="text-sm text-muted-foreground mb-4">
          Los documentos enviados <strong>no se utilizan para entrenar modelos de inteligencia artificial</strong>, ni para fines distintos del proceso de evaluación de candidaturas.
        </p>

        <hr className="my-8 border-border" />

        <h3 className="text-lg font-medium mt-8 mb-3">3. Datos personales tratados</h3>
        <p className="text-sm text-muted-foreground mb-4">
          Los datos que pueden ser tratados incluyen:
        </p>
        <ul className="text-sm text-muted-foreground list-disc pl-6 space-y-1 mb-4">
          <li>Nombre y apellidos</li>
          <li>Dirección de correo electrónico</li>
          <li>Número de teléfono</li>
          <li>Ciudad o lugar de residencia</li>
          <li>Experiencia profesional</li>
          <li>Formación académica</li>
          <li>Habilidades profesionales</li>
          <li>Idiomas</li>
          <li>Enlaces a portfolios o perfiles profesionales</li>
          <li>Contenido del currículum</li>
          <li>Carta de presentación (si se proporciona)</li>
          <li>Documentos adjuntos enviados por el candidato</li>
        </ul>

        <hr className="my-8 border-border" />

        <h3 className="text-lg font-medium mt-8 mb-3">4. Base legal del tratamiento</h3>
        <p className="text-sm text-muted-foreground mb-4">
          La base jurídica para el tratamiento de los datos personales es <strong>el consentimiento del interesado</strong>, otorgado al enviar la candidatura y aceptar la presente política de privacidad.
        </p>
        <p className="text-sm text-muted-foreground mb-4">
          El candidato puede retirar su consentimiento en cualquier momento solicitando la eliminación de sus datos.
        </p>

        <hr className="my-8 border-border" />

        <h3 className="text-lg font-medium mt-8 mb-3">5. Conservación de los datos</h3>
        <p className="text-sm text-muted-foreground mb-4">
          Los datos personales se conservarán durante un máximo de <strong>12 meses</strong> desde la recepción de la candidatura, con el fin de poder considerar al candidato para futuras oportunidades laborales.
        </p>
        <p className="text-sm text-muted-foreground mb-4">
          Transcurrido dicho plazo, los datos serán eliminados de forma segura, salvo que el candidato haya autorizado expresamente su conservación durante más tiempo.
        </p>

        <hr className="my-8 border-border" />

        <h3 className="text-lg font-medium mt-8 mb-3">6. Destinatarios y proveedores tecnológicos</h3>
        <p className="text-sm text-muted-foreground mb-4">
          Para el funcionamiento del sistema de gestión de candidaturas, los datos pueden ser procesados mediante servicios tecnológicos utilizados por la empresa, tales como:
        </p>
        <ul className="text-sm text-muted-foreground list-disc pl-6 space-y-1 mb-4">
          <li>infraestructura de servidores</li>
          <li>bases de datos</li>
          <li>herramientas de análisis de documentos</li>
          <li>servicios de inteligencia artificial utilizados para procesar la información contenida en los currículums</li>
        </ul>
        <p className="text-sm text-muted-foreground mb-4">
          Estos proveedores actúan como <strong>encargados del tratamiento</strong> y procesan los datos únicamente siguiendo instrucciones del responsable del tratamiento y conforme a la normativa de protección de datos aplicable.
        </p>

        <hr className="my-8 border-border" />

        <h3 className="text-lg font-medium mt-8 mb-3">7. Derechos del interesado</h3>
        <p className="text-sm text-muted-foreground mb-4">
          El candidato puede ejercer en cualquier momento los siguientes derechos:
        </p>
        <ul className="text-sm text-muted-foreground list-disc pl-6 space-y-1 mb-4">
          <li>Derecho de acceso a sus datos personales</li>
          <li>Derecho de rectificación de datos inexactos</li>
          <li>Derecho de supresión de los datos</li>
          <li>Derecho de oposición al tratamiento</li>
          <li>Derecho a la limitación del tratamiento</li>
          <li>Derecho a la portabilidad de los datos</li>
        </ul>
        <p className="text-sm text-muted-foreground mb-4">
          Para ejercer estos derechos, el interesado puede enviar una solicitud a: <a href="mailto:hola@brutalco.es" className="text-primary underline hover:no-underline">hola@brutalco.es</a>
        </p>
        <p className="text-sm text-muted-foreground mb-4">
          Indicando en el asunto: <strong>«Protección de datos – Candidaturas»</strong>.
        </p>

        <hr className="my-8 border-border" />

        <h3 className="text-lg font-medium mt-8 mb-3">8. Eliminación de datos</h3>
        <p className="text-sm text-muted-foreground mb-4">
          Los candidatos pueden solicitar en cualquier momento la <strong>eliminación de su candidatura y de todos los datos asociados</strong> enviando una solicitud al correo: <a href="mailto:hola@brutalco.es" className="text-primary underline hover:no-underline">hola@brutalco.es</a>
        </p>
        <p className="text-sm text-muted-foreground mb-4">
          La solicitud será atendida en el menor plazo posible conforme a la normativa de protección de datos aplicable.
        </p>

        <hr className="my-8 border-border" />

        <h3 className="text-lg font-medium mt-8 mb-3">9. Seguridad de los datos</h3>
        <p className="text-sm text-muted-foreground mb-4">
          BRUTAL SC adopta las medidas técnicas y organizativas necesarias para garantizar la seguridad de los datos personales y evitar su alteración, pérdida, tratamiento o acceso no autorizado.
        </p>

        <hr className="my-8 border-border" />

        <h3 className="text-lg font-medium mt-8 mb-3">10. Aceptación de la política</h3>
        <p className="text-sm text-muted-foreground mb-4">
          El envío de la candidatura implica que el candidato <strong>ha leído, comprendido y aceptado la presente Política de Privacidad</strong>, así como el tratamiento de sus datos personales conforme a lo descrito en este documento.
        </p>
      </main>
    </div>
  );
}
